class StickyHeader {
  constructor() {
    this.header = document.getElementById("header");

    this.init();
  }

  init() {
    const headerHeight = this.header.offsetHeight;

    window.addEventListener("scroll", function () {
      const scrollTop = window.scrollY;

      if (scrollTop >= headerHeight) {
        this.header.classList.add("header-sticky", "sticky-active");
      } else {
        this.header.classList.remove("header-sticky", "sticky-active");
      }
    });
  }
}

export default StickyHeader;
